import { Types } from "./RouterConstants";

export function setRouterLink(payload) {
    return (dispatch) => {
        dispatch({ type: Types.SET_ROUTER_LINK, payload: { link: payload} });
    }
}

export function removeRouterLink(payload) {
    return (dispatch) => {
        dispatch({ type: Types.REMOVE_ROUTER_LINK, payload: payload});
    }
}
 
const exports = {
    Types,
}

export default exports;